import type { AuthUser, RoleCode } from '@/types';

/**
 * Owner-corrected allowlist for «Активные докторанты» (Task 14).
 * Canonical four contexts: LEARNER, ADVISOR, DEPARTMENT_HEAD, DEPARTMENT_ASSISTANT.
 * DOCTORAL_STUDENT is the category alias for LEARNER.
 */
export const ACTIVE_DOCTORAL_PANEL_ROLES = new Set<string>([
  'LEARNER',
  'DOCTORAL_STUDENT',
  'ADVISOR',
  'DEPARTMENT_HEAD',
  'DEPARTMENT_ASSISTANT',
]);

export function canShowActiveDoctoralPanel(
  user: Pick<AuthUser, 'activeRole' | 'roles' | 'categories'> | null | undefined,
  previewCode?: string | null,
): boolean {
  if (!user) return false;

  const preview = (previewCode || '').trim().toUpperCase();
  if (preview && ACTIVE_DOCTORAL_PANEL_ROLES.has(preview)) {
    const isOwner =
      user.activeRole === 'SYSTEM_OWNER' ||
      (Array.isArray(user.roles) && user.roles.includes('SYSTEM_OWNER' as RoleCode));
    if (isOwner) return true;
  }

  const candidates = [user.activeRole, ...(user.roles ?? []), ...(user.categories ?? [])].filter(
    Boolean,
  ) as string[];

  if (user.activeRole) {
    return ACTIVE_DOCTORAL_PANEL_ROLES.has(user.activeRole);
  }

  return candidates.some((code) => ACTIVE_DOCTORAL_PANEL_ROLES.has(code));
}
